import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'graphql-connector-panel',
    templateUrl: './graphql.connector.panel.html'
})
export class GraphQLConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@GraphQL',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.GraphQLInfo',
            ControlType: GraphQLConnectorPanel,
            Default: null
        };
    }
}
